import '../../App.css';
import React, { useContext, useEffect } from "react";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';

function ModalCadastrarItem({ closeModal, currentPage }) {
    const { CadastrarItem, CadastroItem, setCadastroItem, Subgrupos, ListaSubgrupo } = useContext(ServicoContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    const handleChange = (event) => {
        setCadastroItem({ ...CadastroItem, [event.target.name]: event.target.value })
    }

    const handleClose = () => {
        setCadastroItem({ descricao: "", subGrupoKey: "" });
        closeModal(false);
    }

    useEffect(() => {
        ListaSubgrupo()
    },[])   

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Cadastrar item</h1>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form onSubmit={(e) => CadastrarItem(e, currentPage)}>
                    <div className="modal-content">
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control maxLength={100} onChange={handleChange} name="descricao" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Subgrupo</Form.Label>
                                    <Form.Select aria-label="Default select example" onChange={handleChange} name="subGrupoKey">
                                        <option value="0">Selecione</option>
                                        {Subgrupos &&
                                            Subgrupos?.sort((a, b) => a?.descricao?.localeCompare(b?.descricao))?.map((item) => {
                                                return (
                                                    <option key={item.id} value={item.key}>{item.descricao}</option>
                                                )
                                            })

                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={handleClose}>Cancelar</button>
                        <button className="btn-dash btn-criar" style={btnCriar}>Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCadastrarItem